import { Box, Grid } from '@mui/material';
import { styled } from '@mui/system';
import LoginBackgroundImage from 'assets/login/back-ground-image.png';

export const AuthPageWrapper = styled(Grid)({
	position: 'relative',
	overflow: 'hidden',
	height: '100%',
	width: '100%',
});

export const PageContainer = styled(Grid)({
	position: 'relative',
	zIndex: 2,
	height: '100%',
	width: '100%',

	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	justifyContent: 'flex-end',

	padding: '0 16px 66px',

	backgroundImage: `url('${LoginBackgroundImage}')`,
	backgroundRepeat: 'no-repeat',
	backgroundSize: 'contain',
	backgroundPosition: 'center top',
});

export const TopElipse = styled(Box)({
	position: 'absolute',
	zIndex: 1,
	top: '-145px',
	left: '-250px',
	width: '582px',
	height: '582px',
	borderRadius: '582px',
	opacity: 0.8,
	background: '#B8E4FF',
	filter: 'blur(184.1431884765625px)',
});

export const BottomElipse = styled(Box)({
	position: 'absolute',
	zIndex: 1,
	bottom: '-550px',
	right: '-550px',
	width: '934px',
	height: '934px',
	borderRadius: '934px',
	opacity: 0.8,
	background: '#6EA8FF',
	filter: 'blur(295.5150146484375px)',
});
